exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content.blank-layout {\n  width: 100%;\n  height: 100%;\n  background-color: transparent !important;\n}\n", ""]);

// exports
